<nz-modal
    nzClassName="cb4-assignment-modal"
    [nzStyle]="{ top: '5vh' }"
    [nzVisible]="state.isOpen"
    [nzTitle]="modalTitle"
    [nzWidth]="'min(1000px, calc(100vw - 24px))'"
    [nzFooter]="null"
    [nzKeyboard]="!isEvidenceModalOpen && !childUserDialogOpen"
    [nzClosable]="!childUserDialogOpen && !newUserReturnPending"
    (nzOnCancel)="close()"
>
    <ng-container *nzModalContent>
        <div *ngIf="initialLoadPending" class="task-form__initial-loading" aria-busy="true">
            <app-loading-indicator message="Loading task form..."></app-loading-indicator>
        </div>
        <ng-container *ngIf="!initialLoadPending">
        <div #taskFormRoot class="task-form" [formGroup]="form">
            <p *ngIf="editLoading" class="task-form__feedback" role="status">
                Loading task details…
            </p>
            <div *ngIf="editError" class="task-form__error">
                <span role="alert">{{ editError }}</span>
                <button nz-button nzType="link" type="button" (click)="reloadEditTask()">Retry</button>
            </div>
            <p *ngIf="editTask" class="task-form__assessment-name">
                <strong>Assessment:</strong> {{ editTask.assessmentLabel }}
            </p>

            <ng-container *ngIf="state.context?.kind === 'create' && !isAssessmentLocked">
                <div class="task-form__field">
                    <label for="task-form-assessment">Assessment <span aria-hidden="true">*</span></label>
                    <nz-select id="task-form-assessment" formControlName="productLicenseId"
                        nzShowSearch nzServerSearch nzAllowClear
                        [nzLoading]="assessmentsLoading"
                        nzPlaceHolder="Select an assessment"
                        (nzOnSearch)="searchAssessments($event)">
                        <nz-option *ngFor="let license of displayedAssessments"
                            [nzValue]="license.id" [nzLabel]="assessmentLabel(license)"></nz-option>
                    </nz-select>
                    <div *ngIf="assessmentsError" class="task-form__error">
                        <span role="alert">{{ assessmentsError }}</span>
                        <button nz-button nzType="link" type="button" (click)="retryAssessments()">Retry</button>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="showTaskFields">
                    <div *ngIf="optionsError" class="task-form__error">
                        <span role="alert">{{ optionsError }}</span>
                        <button *ngIf="!saveConflict" nz-button nzType="link" type="button"
                            (click)="retryOptions()">Retry</button>
                        <button *ngIf="saveConflict && state.context?.kind === 'edit'" nz-button nzType="link"
                            type="button" (click)="reloadEditTask()">Reload current task</button>
                    </div>

                    <div *ngIf="!isStatusOnlyEdit" class="task-form__field">
                        <label for="task-form-assignees">Assigned user(s) <span aria-hidden="true">*</span></label>
                        <nz-select #assigneeSelect id="task-form-assignees" formControlName="assigneeUserIds"
                            [(nzOpen)]="assigneeDropdownOpen" [nzDropdownRender]="addTaskUserDropdown"
                            nzMode="multiple" nzShowSearch nzServerSearch
                            [nzLoading]="optionsLoading"
                            aria-describedby="task-form-assignees-hint"
                            nzPlaceHolder="Search eligible users"
                            (nzOnSearch)="searchAssignees($event)">
                            <nz-option *ngFor="let assignee of displayedAssignees"
                                [nzValue]="assignee.userId" [nzLabel]="assignee.displayName"></nz-option>
                        </nz-select>
                        <ng-template #addTaskUserDropdown>
                            <div *ngIf="canInviteAssessmentUser" class="task-form__dropdown-action" (mousedown)="$event.preventDefault(); $event.stopPropagation()">
                                <button nz-button nzType="primary" class="cb4-button" type="button"
                                    [disabled]="!canLaunchAddUser" (click)="openAssessmentAssignments($event)">
                                    <i nz-icon nzType="team"></i> Edit Assessment Assignees
                                </button>
                                <button nz-button nzType="primary" class="cb4-button" type="button"
                                    [disabled]="!canLaunchAddUser" (click)="openAddUser($event)">
                                    <i nz-icon nzType="user"></i> Add New User
                                </button>
                            </div>
                        </ng-template>
                        <p id="task-form-assignees-hint" class="task-form__hint">
                            Note - only users <button class="task-form__link" type="button" (click)="openAssessmentAssignments()">already assigned</button> to this assessment can be assigned to a task.
                        </p>
                        <span *ngIf="form.controls.assigneeUserIds.touched && form.controls.assigneeUserIds.invalid"
                            class="task-form__error" role="alert">Select at least one eligible user.</span>
                        <div class="task-form__paging" *ngIf="assigneePage.total > 50">
                            <button nz-button nzType="default" type="button" (click)="changeAssigneePage(-1)"
                                [disabled]="optionsLoading || assigneePage.offset === 0">Previous</button>
                            <span>{{ assigneePage.offset + 1 }}–{{ assigneePage.offset + assigneePage.items.length }}
                                of {{ assigneePage.total }}</span>
                            <button nz-button nzType="default" type="button" (click)="changeAssigneePage(1)"
                                [disabled]="optionsLoading || assigneePage.offset + 50 >= assigneePage.total">Next</button>
                        </div>
                    </div>

                    <div *ngIf="!isStatusOnlyEdit && !isRequirementLocked" class="task-form__field">
                        <label for="task-form-requirements">Assigned Controls/Requirements (optional)</label>
                        <nz-select id="task-form-requirements" formControlName="requirementKeys"
                            nzDropdownClassName="task-form__requirements-dropdown"
                            [nzDropdownMatchSelectWidth]="true"
                            nzMode="multiple" nzShowSearch nzServerSearch
                            [nzLoading]="optionsLoading"
                            aria-describedby="task-form-requirements-hint"
                            nzPlaceHolder="Example:  6.4.1"
                            (nzOnSearch)="searchRequirements($event)">
                            <nz-option-group *ngFor="let group of requirementGroups" [nzLabel]="group.label">
                                <nz-option *ngFor="let item of group.items"
                                    [nzValue]="item.key" [nzLabel]="item.label"></nz-option>
                            </nz-option-group>
                        </nz-select>
                        <p id="task-form-requirements-hint" class="task-form__hint">
                            Type a control number or phrase to search in-scope requirements. Leave blank for an assessment-wide task.
                        </p>
                        <span *ngIf="form.controls.requirementKeys.touched && form.controls.requirementKeys.invalid"
                            class="task-form__error" role="alert">Select valid requirements or leave this field blank.</span>
                    </div>

                    <div *ngIf="!isStatusOnlyEdit" class="task-form__field">
                        <label for="task-form-description">Task Description <span aria-hidden="true">*</span></label>
                        <textarea id="task-form-description" formControlName="description" rows="5"
                            [attr.maxlength]="descriptionMaxLength"
                            placeholder="Describe the work to complete"></textarea>
                        <span *ngIf="form.controls.description.touched && form.controls.description.invalid"
                            class="task-form__error" role="alert">Enter a description within the text limit.</span>
                    </div>

                    <div class="task-form__row" [class.task-form__row--status-only]="isStatusOnlyEdit">
                        <div *ngIf="!isStatusOnlyEdit" class="task-form__field">
                            <label for="task-form-due-date">Due date</label>
                            <nz-date-picker id="task-form-due-date" class="task-form__date-picker"
                                nzFormat="d MMMM yyyy" nzPlaceHolder="Select due date"
                                [nzDisabledDate]="dueDateDisabled" [nzDisabled]="state.context?.kind === 'edit' && !editTask?.capabilities?.canEditTask"
                                [ngModel]="dueDatePickerValue" [ngModelOptions]="{ standalone: true }"
                                (ngModelChange)="changeDueDate($event)"></nz-date-picker>
                            <span *ngIf="form.controls.dueDate.touched && form.controls.dueDate.invalid"
                                class="task-form__error" role="alert">Choose a valid future date.</span>
                        </div>
                        <div class="task-form__field">
                            <label for="task-form-status">Status</label>
                            <nz-select id="task-form-status" class="task-form__select"
                                nzDropdownClassName="task-form__select-dropdown" formControlName="status">
                                <nz-option *ngFor="let status of statuses" [nzValue]="status"
                                    [nzLabel]="statusPresentation(status).label"></nz-option>
                            </nz-select>
                        </div>
                    </div>
            </ng-container>

            <div *ngIf="saveError" class="task-form__error">
                <span role="alert">{{ saveError }}</span>
                <button *ngIf="saveConflict && state.context?.kind === 'edit'" nz-button nzType="link"
                    type="button" (click)="reloadEditTask()">Reload current task</button>
            </div>

            <div class="task-form__actions">
                <button *ngIf="showRequiredEvidence" nz-button nzType="primary" type="button"
                    class="cb4-button task-form__required-evidence" [disabled]="!canOpenRequiredEvidence"
                    (click)="openRequiredEvidence()">
                    <i nz-icon nzType="file-search" aria-hidden="true"></i> Manage Required Evidence
                </button>
                <button nz-button nzType="default" type="button" class="cb4-button task-form__cancel"
                    (click)="close()" [disabled]="saving || childUserDialogOpen || newUserReturnPending">Cancel</button>
                <button nz-button nzType="primary" class="cb4-button" type="button" (click)="save()" [disabled]="!canSave">
                    <i nz-icon nzType="plus" aria-hidden="true"></i> {{ saving ? 'Saving…' : state.context?.kind === 'edit' ? 'Save Changes' : 'Add Task' }}
                </button>
            </div>
        </div>
        </ng-container>
    </ng-container>
</nz-modal>
